import { Icon } from "PFComponents/icon";
import { Button } from "PFCore/components/button";
import PropTypes from "prop-types";
import React from "react";

const ExceptionsButton = ({ onClick, children, icon, disabled }) => (
  <Button onClick={onClick} kind="danger" disabled={disabled}>
    <Icon name={icon || "warning"} size="sm" />
    {children}
  </Button>
);

ExceptionsButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.oneOf(["edit", "warning"])
};

export default ExceptionsButton;
